/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

import React from 'react';

const ShouldLinkPhoneNumberContext = React.createContext(false);

export default ShouldLinkPhoneNumberContext;
